exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".food-list .food-item{margin-top:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;line-height:17px}.food-list .food-item .single-price{font-size:12px}.food-list .food-item .name{font-weight:bold}.food-list .food-item .price{font-weight:bold}.product-order{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.quantity-badge{background-color:orange;color:#fff;border-radius:5px;padding:2px 5px;display:inline-block;margin-right:10px;font-weight:bold}", ""]);

// exports
